import { createContext, ComponentChildren } from 'preact';
import { useContext } from 'preact/hooks';
import Shipment from 'interfaces/PmParcel';

interface CurrentShipmentContextState {
  shipment: Shipment;
  updateShipment: (shipment: Shipment) => void;
  reloadShipment: () => void;
}

const CurrentShipmentContext = createContext({} as CurrentShipmentContextState);

interface CurrentShipmentProviderProps {
  shipment: Shipment;
  updateShipment: (shipment: Shipment) => void;
  reloadShipment: (shipmentId: number) => void;
  children: ComponentChildren;
}
export const CurrentShipmentProvider = ({
  shipment,
  updateShipment,
  reloadShipment,
  children,
}: CurrentShipmentProviderProps) => {
  return (
    <CurrentShipmentContext.Provider
      value={{
        shipment,
        updateShipment,
        reloadShipment: () => reloadShipment(shipment.id),
      }}
    >
      {children}
    </CurrentShipmentContext.Provider>
  );
};

export const useCurrentShipment = () => {
  const ctx = useContext(CurrentShipmentContext);

  if (!ctx) {
    throw new Error(
      'useCurrentShipment must be used within a CurrentShipmentProvider',
    );
  }

  return ctx;
};
